import  { Socket} from "rete";

var AnyTypeSocket = new Socket('Any Type');

var ArraySocket = new Socket('Common.Socket.Array');
ArraySocket.combineWith(AnyTypeSocket);

var DateTimeSocket = new Socket('Common.Socket.DateTime');
DateTimeSocket.combineWith(AnyTypeSocket);

var BooleanSocket = new Socket('Common.Socket.Boolean');
BooleanSocket.combineWith(AnyTypeSocket);

export default AnyTypeSocket;
export { ArraySocket,DateTimeSocket,BooleanSocket};
